import React from 'react';
import { LegalInfoItem } from '@plus-int/acq-toolkit';

import { Link } from '@/shared/components/Link/Link';
import { interpolateOfferText } from '@/shared/lib/text';

import styles from './InterpolatedOfferText.module.css';

interface Props {
    text?: string;
    legals?: LegalInfoItem[];
    className?: string;
}

function InterpolatedOfferTextComponent({ text, legals, className }: Props) {
    if (!text) return null;

    const interpolatedText = interpolateOfferText(text, legals).map((part) =>
        typeof part === 'string' ? (
            part
        ) : (
            <Link
                href={part.link}
                rel="noopener noreferrer"
                target="_blank"
                className={styles.legalLink}
            >
                {part.text}
            </Link>
        )
    );

    return <span className={className}>{interpolatedText}</span>;
}

export const InterpolatedOfferText = React.memo(InterpolatedOfferTextComponent);
